export const ORDER_SUMMARY_LINE_ITEM_WIDTH = '150px';
